import $ from 'jquery';

export const ELEMENT_SELECTOR = '[data-focus-element]';
export const PLUGIN_NAME = 'FocusElement';


$(document).ready(() => {
  $(ELEMENT_SELECTOR).each(function () {
    const element = this;
    System.import(/* webpackChunkName: "plugin--focus-element" */ './plugin')
      .then(() => {
        $(element)[PLUGIN_NAME]();
      });
  });
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__focus/index.js